import { render, staticRenderFns } from "./FormSearch.vue?vue&type=template&id=3a4ccb18&scoped=true&lang=pug&"
import script from "./FormSearch.vue?vue&type=script&lang=js&"
export * from "./FormSearch.vue?vue&type=script&lang=js&"
import style0 from "./FormSearch.vue?vue&type=style&index=0&id=3a4ccb18&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4ccb18",
  null
  
)

export default component.exports